import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import GallectionsGrid from '../GallectionGrid';
import SearchInput from '../../_partials/SearchInput';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import FolderCard from '../../_partials/FolderCard';
import LoadingIndicator from '../../../LoadingIndicator';
import withGallections from '../../_hocs/withGallections';
import { withMobileContext } from '../../../Context';
import { withFeatureFlags } from '../../../redux/flags';
var enhance = compose(withGallections, withMobileContext, withFeatureFlags, withTranslation());
var GallectionExplorer = /** @class */ (function (_super) {
    tslib_1.__extends(GallectionExplorer, _super);
    function GallectionExplorer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchMoreGallectionsIfNeeded = function () {
            var _a = _this.props, hasMoreGallections = _a.hasMoreGallections, isFetchingGallections = _a.isFetchingGallections, fetchMoreGallections = _a.fetchMoreGallections;
            if (!hasMoreGallections || isFetchingGallections) {
                return;
            }
            fetchMoreGallections();
        };
        _this.renderGallection = function (gallection) {
            return React.createElement(FolderCard, { folder: gallection });
        };
        return _this;
    }
    GallectionExplorer.prototype.render = function () {
        return (React.createElement(PopupInnerLayout, { headerExtrasRightZone: React.createElement(SearchInput, null), scrollableContent: this.renderContent(), onScrolledToBottom: this.fetchMoreGallectionsIfNeeded, onNotScrollable: this.fetchMoreGallectionsIfNeeded }));
    };
    GallectionExplorer.prototype.renderContent = function () {
        var _a = this.props, isGallectionStreamInitialized = _a.isGallectionStreamInitialized, gallections = _a.gallections, hasMoreGallections = _a.hasMoreGallections;
        return (React.createElement(React.Fragment, null,
            isGallectionStreamInitialized && (React.createElement(GallectionsGrid, { gallections: gallections, gallectionRenderer: this.renderGallection })),
            hasMoreGallections && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !gallections.length && hasMoreGallections }))));
    };
    return GallectionExplorer;
}(React.Component));
export { GallectionExplorer };
export default enhance(GallectionExplorer);
//# sourceMappingURL=GallectionExplorer.connected.js.map